var $ = require('jquery');
import { gsap } from 'gsap';
var carousels = global.carousels;


var tabsAndContent = $('.tabs-and-content');
$(function() {
    if ( tabsAndContent.length ) {
        tabsAndContent.each(function(index, parent) {
            var _this = $(this);
            var content = _this.find('.tabs-and-content__content');
            var tabs = _this.find('.tabs-and-content__tab');
    
            $(window).on('resize', debounce(function() {
                if ( $(window).width() > 768 ) {
                    _this.find('.tabs-and-content__content[data-content-num="1"]').addClass('is-selected');
                    _this.find('.tabs-and-content__tab[data-tab-num="1"]').addClass('is-selected');
                }
        
                tabs.each(function(num, tab) {
                    if ( $(window).width() > 768 ) {
                        $(this).on('click', {
                            parent: parent, 
                            tab: tab,
                            num: num,
                            content: content,
                        }, toggleClasses);
                    } else {
                        $(this).off('click');
                    }
                })
    
            }, 250)).trigger('resize');
        })
    }  
})

function toggleClasses(e) {
    var content = e.data.content, parent = e.data.parent, tab = e.data.tab, num = e.data.num;
    $(parent).find('.tabs-and-content__tab.is-selected').removeClass('is-selected');
    $(parent).find('.tabs-and-content__content.is-selected').removeClass('is-selected');
    $(tab).addClass('is-selected');
    $(content).eq(num).addClass('is-selected');
}



function debounce(func, delay) {
    let debounceTimer;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
            func.apply(context, args);
        }, delay);
    };
};